/* In-house wishlist (Phase 3). Logged-in → App Proxy (customer metafield);
   guest → localStorage, synced on next login. */
(function () {
  "use strict";
  var LS_KEY = "wl_items";
  var buttons = document.querySelectorAll(".wl-btn[data-product-id]");
  if (!buttons.length) return;

  var loggedIn = buttons[0].getAttribute("data-logged-in") === "1";
  var path = buttons[0].getAttribute("data-wishlist-path") || "/apps/ai/wishlist";

  function lsGet() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch (e) { return []; }
  }
  function lsSet(items) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function gid(id) { return String(id).indexOf("gid://") === 0 ? id : "gid://shopify/Product/" + id; }

  function setActive(btn, on) {
    btn.classList.toggle("is-active", on);
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.querySelector(".wl-heart").textContent = on ? "♥" : "♡";
    btn.querySelector(".wl-label").textContent = on ? "Saved" : "Save";
  }

  // Load current state.
  function reflect(ids) {
    Array.prototype.forEach.call(buttons, function (btn) {
      setActive(btn, ids.indexOf(gid(btn.getAttribute("data-product-id"))) !== -1);
    });
  }

  if (loggedIn) {
    // Sync any guest localStorage items up, then load server state.
    var pending = lsGet();
    var syncs = pending.map(function (it) {
      return fetch(path, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "add", productId: it.productId, handle: it.handle })
      }).catch(function () {});
    });
    Promise.all(syncs).then(function () {
      if (pending.length) lsSet([]);
      fetch(path, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (d) { reflect((d.items || []).map(function (i) { return i.productId; })); });
    });
  } else {
    reflect(lsGet().map(function (i) { return i.productId; }));
  }

  Array.prototype.forEach.call(buttons, function (btn) {
    btn.addEventListener("click", function () {
      var pid = gid(btn.getAttribute("data-product-id"));
      var handle = btn.getAttribute("data-handle");
      var nowActive = !btn.classList.contains("is-active");
      setActive(btn, nowActive);

      if (loggedIn) {
        // Saving a sold-out product also subscribes to a back-in-stock alert.
        var outOfStock = btn.getAttribute("data-in-stock") === "0";
        var body = { action: nowActive ? "add" : "remove", productId: pid, handle: handle };
        if (nowActive && outOfStock) body.alerts = ["back_in_stock"];
        fetch(path, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        }).catch(function () { setActive(btn, !nowActive); });
      } else {
        var items = lsGet().filter(function (i) { return i.productId !== pid; });
        if (nowActive) items.push({ productId: pid, handle: handle });
        lsSet(items);
      }
    });
  });
})();
